import { deref } from "kanopi-components/utils";
import { useAPI } from "kw/api/useAPI";
import { useState } from "react";

export const useIsActionAllowed = (query: unknown, responseKey: string) => {
  const { query: queryAPI } = useAPI();
  const [data, setData] = useState<{
    loading: boolean;
    isAllowed: boolean;
  }>({
    loading: undefined,
    isAllowed: undefined,
  });
  const queryIsActionAllowed = () => {
    setData({
      loading: true,
      isAllowed: false,
    });
    queryAPI(query, (response) => {
      const isAllowed = deref(response, responseKey);
      setData({
        loading: false,
        isAllowed,
      });
    });
  };
  return { queryIsActionAllowed, data };
};
